import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/General/General/Views/general.html";
import Spinner from "@/Pages/Admin/Modules/Common/Controllers/Spinner";
import GeneralStore from "@/Pages/Admin/Modules/Hotel/Store/General";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";

import GeneralModule from "@/Pages/Admin/Modules/Hotel/Store/General";
import { HotelModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelModel";
import { PropertyTypeModel } from "@/Pages/Admin/Modules/Models/Hotel/PropertyTypeModel";

import { hotelService } from "../../../../Services/HotelService";

@WithRender
@Component({
  components: {
    Spinner,
    "validation-error": ValidationError,
  },
})
export default class General extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected status: any = {};

  constructor() {
    super();
    this.status.Edit = false;

    this.ui = {
      index: {
        edit: -1,
        isEdit: false,
        delete: -1,
        up: 0,
        down: 0,
      },
      status: {
        isLoading: {
          generalList: false,
          propertyType: false,
        },
        postLoading: {
          generalList: false,
          propertyType: false,
        },
        canAdd: false,
      },
      error: {
        errors: [],
        validationErrors: {},
        hasError: false,
      },
    };
    this.item = {
      hotelId: 0,
      generalList: new HotelModel({}),
      editGeneral: new HotelModel({}),
      propertyType: new PropertyTypeModel({}),
    };
  }

  public beforeMount() {
    this.item.hotelId = this.$route.query.id;
    this.getAllPropertyType();
  }

  public mounted() {
    this.getGeneral();
  }

  protected async getAllPropertyType() {
    this.ui.status.isLoading.propertyType = true;
    trekService
      .getPropertyType()
      .then((res: any) => {
        this.item.propertyType = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.propertyType = false;
      });
  }

  protected getGeneral() {
    this.ui.IsLoading = true;
    const data = {
      hotel_id: this.item.hotelId,
    };
    hotelService
      .getGeneralTabData(data)
      .then((res: any) => {
        this.ui.IsLoading = false;
        this.item.generalList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }

  public get buttonName() {
    if (this.ui.PostLoading) {
      return "Processing...";
    }
    return "Save";
  }

  get propertyId() {
    if (
      this.item.generalList.property_type &&
      this.item.generalList.property_type.id
    ) {
      return this.item.generalList.property_type.id;
    }
  }

  protected setGeneral() {
    this.ui.error.validationErrors = {};
    this.ui.error.errors = [];
    this.ui.error.hasError = false;

    if (!this.IsValidationTrue()) {
      return;
    }
    this.ui.status.postLoading.generalList = true;
    const data = {
      hotel_id: this.item.hotelId,
      title: this.item.generalList.title,
      address: this.item.generalList.address,
      email: this.item.generalList.email,
      hotel_star: this.item.generalList.hotel_star,
      phone: this.item.generalList.phone,
      intro_text: this.item.generalList.intro_text,
      is_pet_allow: this.item.generalList.is_pet_allow,
      property_type_id: this.propertyId,
    };
    hotelService
      .PutGeneral(data)
      .then((res: any) => {
        this.ui.error.hasError = false;
        this.item.generalList = res.data.data;
        GeneralModule.setHotelTitle(res.data.data);
        flashService.Success("General Data Saved", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.generalList = false;
        this.status.Edit = false;
      });
  }

  protected IsValidationTrue() {
    if (!this.item.generalList.title) {
      Object.assign(this.ui.error.validationErrors, {
        title: ["The title field is required."],
      });
    }
    if (!this.item.generalList.email) {
      Object.assign(this.ui.error.validationErrors, {
        email: ["The email field is required."],
      });
    }
    if (!this.item.generalList.address) {
      Object.assign(this.ui.error.validationErrors, {
        address: ["The address field is required."],
      });
    }
    if (!this.item.generalList.intro_text) {
      Object.assign(this.ui.error.validationErrors, {
        intro_text: ["The intro_text level field is required."],
      });
    }
    if (!this.item.generalList.phone) {
      Object.assign(this.ui.error.validationErrors, {
        phone: ["The phone field is required."],
      });
    }

    if (common.notEmpty(this.ui.error.validationErrors)) {
      this.ui.error.hasError = true;
      return false;
    } else {
      return true;
    }
  }

  protected editGeneral() {
    this.status.Edit = true;
    this.item.editGeneral = Object.assign({}, new HotelModel({}));
    this.item.editGeneral = Object.assign({}, this.item.generalList);
  }

  protected cancelGeneralEdit() {
    this.status.Edit = false;
    this.ui.error.errors = [];
    this.ui.error.validationErrors = {};
    this.ui.error.hasError = false;
    this.item.generalList = this.item.editGeneral;
  }

  protected hideIcon() {
    $(".informative-block").hide();
  }
}
